// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatDeleteStandaloneBody = {
  chatId: string;
};

export type typeChatDeleteStandaloneOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isDeleted: boolean };
};

export type typeChatDeleteStandaloneOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatDeleteStandaloneOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatDeleteStandaloneOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatDeleteStandaloneBody = {
  type: "object",
  properties: { chatId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatDeleteStandalone(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatDeleteStandaloneBody);
  }

  return async function postChatDeleteStandalone(
    payload: typeChatDeleteStandaloneBody,
  ): Promise<
    typeChatDeleteStandaloneOutput200 | typeChatDeleteStandaloneOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatDeleteStandalone" failed before calling the network. #6ee40cc1a2d2`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#6ee40cc1a2d2" },
        },
        data: null,
      } as typeChatDeleteStandaloneOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/delete-standalone`,
      httpMethod: "POST",
      options,
    })) as
      typeChatDeleteStandaloneOutput200 | typeChatDeleteStandaloneOutput400;
  };
}
